import { NgModule } from '@angular/core';
import { AutoFocusDirective } from './auto-focus.directive';
import { DebounceControlDirective } from './DebounceControlDirective';
import { DragDropDirective } from './drag-drop.directive';
import { InsertionDirective } from './insertion.directive';
import { LazyLoadDirective } from './lazyload.directive';
import { RemoteValidatorDirective } from './remote-validator.directive';
import { ResponsiveCheckDirective } from './responsive-check.directive';
import { SliderDirective } from './slider.directive';
import { SocialShare } from './social-share';
const IMPORT_DIRECTIVE = [
  DebounceControlDirective,
  DragDropDirective,
  RemoteValidatorDirective,
  SliderDirective,
  AutoFocusDirective,
  ResponsiveCheckDirective,
  LazyLoadDirective,
  SocialShare,
  InsertionDirective,
]
@NgModule({
  declarations: [...IMPORT_DIRECTIVE],
  imports: [],
  exports: [...IMPORT_DIRECTIVE]
})
export class DirectiveModule { }